export const INVESTOR_ALPHA_PREFERENCES = ["growth", "balance", "protect"] as const;

export type InvestorAlphaPreference = (typeof INVESTOR_ALPHA_PREFERENCES)[number];

export const INVESTOR_ALPHA_RECOMMENDATIONS = ["protect", "balanced", "growth"] as const;

export type InvestorAlphaRecommendationId = (typeof INVESTOR_ALPHA_RECOMMENDATIONS)[number];

export const INVESTOR_ALPHA_BROKERAGE_CHOICES = ["existing", "new"] as const;

export type InvestorAlphaBrokerageChoice = (typeof INVESTOR_ALPHA_BROKERAGE_CHOICES)[number];

export const INVESTOR_ALPHA_IBKR_SETUP_RESPONSES = ["yes-existing", "yes-new"] as const;

export type InvestorAlphaIbkrSetupResponse =
  (typeof INVESTOR_ALPHA_IBKR_SETUP_RESPONSES)[number];

export const INVESTOR_ALPHA_TIME_HORIZONS = [
  "under-2",
  "2-to-5",
  "5-to-10",
  "more-than-10",
] as const;

export type InvestorAlphaTimeHorizon = (typeof INVESTOR_ALPHA_TIME_HORIZONS)[number];

export interface InvestorAlphaRouteState {
  alphaPreviousPath?: unknown;
  alphaDevPreview?: unknown;
  preference?: unknown;
  recommendationId?: unknown;
  brokerageChoice?: unknown;
  ibkrSetupResponse?: unknown;
  accountName?: unknown;
  accountType?: unknown;
  timeHorizon?: unknown;
  plutusInvestment?: unknown;
  totalPortfolio?: unknown;
  plutusPercentage?: unknown;
  investmentExperience?: unknown;
  riskScore?: unknown;
  mixId?: unknown;
  customerStatus?: unknown;
  alphaReviewCompleted?: unknown;
  alphaAllocationProvisioningPending?: unknown;
}
